import LoginHeader from "@components/LoginHeader"
import { ReactNode } from "react"

export default function Layout({
  children,
  withLoginHeader = false,
}: {
  children: ReactNode
  withLoginHeader?: boolean
}) {
  return (
    <div className="min-h-dvh animate-change-bg from-[#F5E1EF] to-[#DFF8FC]">
      <div className="flex min-h-dvh flex-col bg-gradient-to-b from-white to-transparent">
        {withLoginHeader && <LoginHeader />}

        <main className="custom-container flex grow flex-col justify-between gap-8 pb-14 pt-8">
          {children}
        </main>
      </div>
    </div>
  )
}
